import {
  FDBox,
  FDDialogContent,
  FDDialogTitle, FDPrimaryActionButton, FDPrimaryActionIconButton, FDSelectInput,
  FDStack,
} from '@facet-wealth/design';
import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { PreviewItem } from 'Components/ComponentLibrary/Components/Uncategorized/FileViewer/components/PreviewItem';
import { openURLInNewTab } from 'Helpers/Navigation';
import RefreshButton from 'Components/ComponentLibrary/Molecules/RefreshButton/RefreshButton';
import { displayErrorMessageWithChecks } from 'Context/SnackbarContext/utils';
import { buildPageLinkByUserType } from 'Views/Page/Content/Templates';

const UploadedAccountStatementDetailView = ({
  setUploadedAccountStatementDetailResource, setUploadedAccountStatementDetailIndex, uploadedAccountStatementDetailResource, uploadedAccountStatementDetailIndex, uploadedAccountStatementsResource, setUploadedAccountStatementsCollection,
}) => {
  const statements = uploadedAccountStatementsResource.attr('statements').resources().list();
  const { displayErrorMessage } = useSnackbarContext();
  const [showRefresh, setShowRefresh] = React.useState(false);

  const onNextOrPrev = async (newIndex) => {
    try {
      const [statementDetail] = await statements[newIndex].relationship(fr.relationships.details.name).link('related').get();
      setUploadedAccountStatementDetailResource(statementDetail);
      setUploadedAccountStatementDetailIndex(newIndex);
    } catch (e) {
      displayErrorMessageWithChecks(e, displayErrorMessage, 'Failed to view statement');
    }
  };

  const onAddAccount = (rel) => {
    const params = uploadedAccountStatementDetailResource.withRelationship(fr.relationships.addRealAssetOrAccountWizard.name, (wizardRel) => {
      return { modalSelfLink: wizardRel.link('related').url() };
    }, () => {});
    const pageLink = buildPageLinkByUserType(rel.link('related').url(), true, params, {});
    openURLInNewTab(pageLink);
    setShowRefresh(true);
  };

  const handleOnChangeAssociatedAccounts = async (val) => {
    try {
      const resourceToSubmit = uploadedAccountStatementDetailResource;
      resourceToSubmit.attr('associatedAccounts', val);
      const [updatedResource] = await resourceToSubmit.submit();
      setUploadedAccountStatementDetailResource(updatedResource);
      const updatedCollection = await uploadedAccountStatementsResource.link('self').get();
      setUploadedAccountStatementsCollection(updatedCollection);
    } catch (e) {
      displayErrorMessageWithChecks(e, displayErrorMessage, 'Failed to change associated account');
    }
  };

  return (
    <FDStack direction={'column'}>
      <FDDialogTitle value={uploadedAccountStatementDetailResource.attr('statementName')} />
      <FDDialogContent>
        <FDStack direction={'column'} spacing={2}>
          <FDStack direction={'row'} justifyContent={'space-between'} alignItems={'center'} spacing={1}>
            <FDStack direction={'row'} spacing={1} alignItems={'center'}>
              <FDSelectInput
                options={uploadedAccountStatementDetailResource.meta().field('associatedAccounts').options().list()
                  .map(option => ({
                    prompt: option.attr('prompt'),
                    id: option.attr('id'),
                  }))}
                value={uploadedAccountStatementDetailResource.attr('associatedAccounts')}
                multiple
                label={uploadedAccountStatementDetailResource.meta().field('associatedAccounts').attr('prompt')}
                onChange={(val) => handleOnChangeAssociatedAccounts(val)}
              />
              {uploadedAccountStatementDetailResource.withRelationship(fr.relationships.addAccount.name, (rel) => {
                return (
                  <FDPrimaryActionIconButton
                    icon={'add'}
                    onClick={() => onAddAccount(rel)}
                    openInNewTab
                  />
                );
              }, () => null)
              }
              <RefreshButton
                showRefresh={showRefresh}
                setShowRefresh={() => setShowRefresh(false)}
                resourceToRefresh={uploadedAccountStatementDetailResource}
                setRefreshedResource={setUploadedAccountStatementDetailResource}
              />
            </FDStack>
            <FDStack direction={'row'} spacing={1}>
              <FDPrimaryActionButton
                label={'Previous'}
                icon={'chevronLeft'}
                size={'sm'}
                disabled={uploadedAccountStatementDetailIndex === 0}
                onClick={() => onNextOrPrev(uploadedAccountStatementDetailIndex - 1)}
              />
              <FDPrimaryActionButton
                label={'See all'}
                size={'sm'}
                onClick={() => setUploadedAccountStatementDetailResource(null)}
              />
              <FDPrimaryActionButton
                label={'Next'}
                icon={'chevronRight'}
                size={'sm'}
                iconPosition={'end'}
                disabled={uploadedAccountStatementDetailIndex === (statements.length - 1)}
                onClick={() => onNextOrPrev(uploadedAccountStatementDetailIndex + 1)}
              />
            </FDStack>
          </FDStack>
          {
            uploadedAccountStatementDetailResource.withRelationship(fr.relationships.file.name,
              (rel) => (
                <FDBox height={'550px'}>
                  <PreviewItem
                    attachmentName={rel.meta('title')}
                    attachmentHref={rel.link('related').url()}
                    presentsAsDownloadable={uploadedAccountStatementDetailResource.withRelationship(fr.relationships.presentsAsDownloadable.name, () => true, () => false)}
                  />
                </FDBox>
              ),
              () => null)
          }
        </FDStack>

      </FDDialogContent>
    </FDStack>);
};


UploadedAccountStatementDetailView.propTypes = {
  uploadedAccountStatementsResource: PropTypes.instanceOf(fr.Resource).isRequired,
  setUploadedAccountStatementDetailResource: PropTypes.func.isRequired,
  uploadedAccountStatementDetailResource: PropTypes.instanceOf(fr.Resource).isRequired,
  setUploadedAccountStatementDetailIndex: PropTypes.func.isRequired,
  uploadedAccountStatementDetailIndex: PropTypes.number.isRequired,
  setUploadedAccountStatementsCollection: PropTypes.func.isRequired,
};

UploadedAccountStatementDetailView.defaultProps = {
};


export default UploadedAccountStatementDetailView;
